import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-theme-management" }
const _hoisted_2 = { class: "kn-list--column kn-page p-col-2 p-sm-2 p-md-3 p-p-0" }
const _hoisted_3 = {
  key: 0,
  class: "p-col p-p-0 p-m-0 kn-page"
}
const _hoisted_4 = {
  key: 1,
  class: "p-col p-p-0 p-m-0 kn-page"
}
const _hoisted_5 = {
  key: 2,
  class: "kn-list--column kn-page p-col-2 p-sm-2 p-md-3 p-p-0"
}
const _hoisted_6 = { class: "p-p-2 p-mt-2 p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-float-label kn-flex" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "themeName",
  class: "kn-material-input-label"
}, " Theme name ", -1)
const _hoisted_9 = {
  key: 0,
  class: "p-p-2 kn-page-content"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_12 = {
  for: "exampleTextInput",
  class: "kn-material-input-label"
}
const _hoisted_13 = {
  key: 1,
  class: "p-float-label"
}
const _hoisted_14 = {
  for: "exampleTextInput",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_ThemeManagementExamples = _resolveComponent("ThemeManagementExamples")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Fieldset = _resolveComponent("Fieldset")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.themeManagement.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_FabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.toggleAdd
          }, null, 8, ["onClick"]),
          _createVNode(_component_Menu, {
            ref: "menu",
            model: _ctx.addMenuItems,
            popup: true,
            style: {"width":"240px"}
          }, null, 8, ["model"])
        ]),
        _: 1
      }),
      _createVNode(_component_KnInputFile, {
        label: "",
        "change-function": _ctx.uploadTheme,
        accept: "application/json,application/zip",
        "trigger-input": _ctx.triggerInput
      }, null, 8, ["change-function", "trigger-input"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_KnListBox, {
        options: _ctx.availableThemes,
        selected: _ctx.selectedTheme,
        settings: _ctx.descriptor.knListSettings,
        onClick: _ctx.selectTheme,
        onDelete: _withModifiers(_ctx.deleteThemeConfirm, ["stop"])
      }, null, 8, ["options", "selected", "settings", "onClick", "onDelete"])
    ]),
    (!_ctx.selectedTheme.themeName)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_KnHint, {
            title: _ctx.$t('managers.themeManagement.title'),
            hint: _ctx.$t('managers.themeManagement.hint')
          }, null, 8, ["title", "hint"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedTheme.themeName)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_ThemeManagementExamples, {
            properties: _ctx.selectedTheme.config
          }, null, 8, ["properties"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedTheme.themeName)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.themeToSend.themeName), 1)
            ]),
            end: _withCtx(() => [
              (_ctx.selectedTheme.id)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-download",
                    class: "p-button-text p-button-rounded p-button-plain",
                    onClick: _ctx.downloadTheme,
                    title: _ctx.$t('managers.themeManagement.download')
                  }, null, 8, ["onClick", "title"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                icon: "pi pi-save",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _ctx.handleSave,
                title: _ctx.$t('managers.themeManagement.save')
              }, null, 8, ["onClick", "title"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_InputText, {
                id: "themeName",
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.themeToSend.themeName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.themeToSend.themeName = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_8
            ]),
            _withDirectives(_createVNode(_component_InputSwitch, {
              modelValue: _ctx.themeToSend.active,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.themeToSend.active = $event))
            }, null, 8, ["modelValue"]), [
              [_directive_tooltip, 'active']
            ])
          ]),
          _createVNode(_component_Divider, { class: "p-my-2" }),
          (_ctx.selectedTheme.themeName)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.themeHelper.descriptor, (value, key) => {
                    return (_openBlock(), _createBlock(_component_Fieldset, {
                      key: key,
                      legend: key,
                      toggleable: true,
                      collapsed: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.properties, (property) => {
                          return (_openBlock(), _createBlock("div", {
                            key: property.key
                          }, [
                            _createVNode("div", _hoisted_10, [
                              (property.type === 'text')
                                ? (_openBlock(), _createBlock("span", _hoisted_11, [
                                    _createVNode(_component_InputText, {
                                      id: "exampleTextInput",
                                      class: "kn-material-input p-inputtext-sm",
                                      type: "text",
                                      onChange: ($event: any) => (_ctx.updateModelToSend(property.key)),
                                      modelValue: _ctx.selectedTheme.config[property.key],
                                      "onUpdate:modelValue": ($event: any) => (_ctx.selectedTheme.config[property.key] = $event)
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"]),
                                    _createVNode("label", _hoisted_12, _toDisplayString(property.label), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (property.type === 'color')
                                ? (_openBlock(), _createBlock("span", _hoisted_13, [
                                    _createVNode(_component_InputText, {
                                      id: "exampleTextInput",
                                      class: "kn-material-input p-inputtext-sm",
                                      type: "text",
                                      modelValue: _ctx.selectedTheme.config[property.key],
                                      "onUpdate:modelValue": ($event: any) => (_ctx.selectedTheme.config[property.key] = $event),
                                      onChange: ($event: any) => (_ctx.updateModelToSend(property.key))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                    _withDirectives(_createVNode("input", {
                                      type: "color",
                                      "onUpdate:modelValue": ($event: any) => (_ctx.selectedTheme.config[property.key] = $event),
                                      onChange: ($event: any) => (_ctx.updateModelToSend(property.key))
                                    }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                      [_vModelText, _ctx.selectedTheme.config[property.key]]
                                    ]),
                                    _createVNode("label", _hoisted_14, _toDisplayString(property.label), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["legend"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}